import React from 'react';
import { observer } from 'mobx-react';
import { Spring } from 'react-spring';
import BottomScrollListener from 'react-bottom-scroll-listener';

import { url } from 'js/services/Network';
import analytics from 'js/services/Analytics';
import { blueColor, lightGrey1Color } from 'js/config/style';
import MyItemsPageState from 'js/stores/pages/MyItemsPageState';
import PageComponent from 'js/components/pages/PageComponent';
import AppContent from 'js/components/AppContent';
import Constraint from 'js/components/Constraint';
import Backdrop from 'js/components/core/Backdrop';

import PageTitle from './PageTitle';
import ItemsList from './ItemsList';
import AddItemButton from './AddItemButton';
import Notice from './Notice';
import Label from './Label';
import ReactComponent from './share.svg';
import {Tooltip} from "reactstrap";
import SellerItemsPageState from "js/stores/pages/SellerItemsPageState";
import AppUser from 'js/stores/AppUser';

const offset = '1.25rem';

@observer
export default class SellerItemsPage extends PageComponent {
  pageName = 'SellerItemsPage';
  trackingName = 'SP_seller_checkout';
  loginRequired = false;
  pageColor = lightGrey1Color;
  pageWidth = '600px';
  timerId = null;

  constructor(props){
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
      clicked: false,
    };
    this.page = SellerItemsPageState.create({
      micro_store: this.props.alias,
    });
    // console.log(props);

  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  copyUrl = () => {
    navigator.clipboard.writeText(this.page.micro_store);
    this.setState({clicked: true});

    if(this.timerId) {
      clearTimeout(this.timerId);
    }

    setTimeout(() => {
      this.setState({clicked: false});
    }, 5000);
  };

  bootstrap = () => this.page.load(true).then(() => {/*analytics.page('My Items Page')*/});

  renderPage() {
    const page = this.page;
    // console.log("seller items page: ", page);
    localStorage.setItem("STORE_CURRENCY", page.seller_country)
    return (
      <AppContent className="seller-items-page" padded>
        <Backdrop offset={offset}>
          <Constraint>
            <PageTitle>
              {`${page.seller_name || AppUser.login}'s store`}
            </PageTitle>
          </Constraint>
        </Backdrop>

        <Constraint offset={offset}>
          {page.items.length ? (
            <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
              {animation => <ItemsList style={animation} endpoint='checkout-page' addButton={false} />}
            </Spring>
          ) : <div className="seller-no-items">
            <h2>{page.seller_name} has no items for sale yet.</h2>
          </div>}
        </Constraint>

        <BottomScrollListener onBottom={page.loadMore} />
      </AppContent>
    );
  }
}
